import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';

const shouldInitializeDynatrace = () => {
  const env = getEnv();
  const urlParams = new URLSearchParams(window.location.search);

  return (
    env !== ENVS.PRODUCTION || urlParams.get('dynatraceInitialize') === 'true'
  );
};

export function setDynatraceUser(analyticsId?: string) {
  if (!shouldInitializeDynatrace()) {
    return;
  }

  if (!window.dtrum) {
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value:
        'Tried to authenticate Dynatrace with user before Dynatrace was initialized',
      context: {
        analyticsId,
      },
    });
    return;
  }

  if (!analyticsId) {
    report({
      scope: 'ACCExoSkeleton',
      type: REPORT_TYPES.error,
      value: 'Tried to authenticate Dynatrace with empty analyticsId',
      context: {},
    });
    return;
  }

  window.dtrum.identifyUser(analyticsId);
}
